import { useEffect, useState } from "react";

import { useAdminEncodeCachingApi } from "./useAdminEncodeCachingApi";

export interface EncodeCachingManagerItem {
    count: number;
}

export const useEncodeCachingManagerItem = () => {
    const [item, setItem] = useState<EncodeCachingManagerItem>({} as EncodeCachingManagerItem);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { count } = useAdminEncodeCachingApi();

    useEffect(() => {
        loadData();
    }, []);

    const resetCount = () => {
        setItem({ count: 0 });
    };

    const loadData = async (): Promise<void> => {
        setIsLoading(true);
        const response = await count();

        setItem({ count: response.count });
        setIsLoading(false);
    };

    return {
        item,
        isLoading,
        resetCount
    };
};
